import React, { PureComponent } from "react"
import { Link } from "react-router-dom"
import { FormattedMessage } from "react-intl"
import { ChevronRight } from "react-feather"
import Box from "../../lib/ui/ui-box"
import Button from "../../components/button"
import Text from "../../components/text"
import Logo from "../../components/logo"
import { getUserLanguage } from "../../utils/analytics"

class Container extends PureComponent {
  render() {
    const { intl } = this.props
    return (
      <Box
        flexDirection={["column"]}
        bg="white"
        align="center"
        style={{ height: "100vh" }}
      >
        <Text
          fontFamily="Libre Baskerville"
          fontSize={[3, 4, 5, 5]}
          lineHeight={[3, 4, 5, 5]}
          mt={[13]}
          fontWeight="700"
          w="552px"
          color="#2B3E51"
          alignText="center"
        >
          <FormattedMessage
            id="get_quote.title"
            defaults="What is your current situation?"
          />
        </Text>
        <Box
          flexDirection="column"
          w="100vw"
          align="flex-start"
          justify="center"
        >
          <Link
            to={intl.formatMessage({ id: "routes.home" })}
            style={{ position: "absolute", top: "20px", left: "70px" }}
          >
            <Box flexDirection="column" align="center" pl={[1]}>
              <Logo src="logo/Nesto_Equity_Logo.png" alt="Nesto Logo" />
            </Box>
          </Link>
          <Box
            pt={[5]}
            w="100vw"
            flexDirection={["column", "row", "row"]}
            align="center"
            justify="center"
          >
            <Box
              flex={0.5}
              pr={[0, 0, 2]}
              pl={[0]}
              pt={[0]}
              flexDirection="column"
              align="flex-end"
              justify="center"
            >
              <Link to={`${intl.formatMessage({ id: "routes.reverse" })}/1`}>
                <Button
                  onClick={() =>
                    window.analytics.track("begin process", {
                      category: "reverse mortgage flow",
                      label: "APPLY",
                      location: "choice page",
                      language: getUserLanguage()
                    })
                  }
                  bg="actionPrimary"
                  pl={[1]}
                  pr={[1]}
                  size="fluid"
                  type="hero"
                  justify="space-between"
                  w={["280px"]}
                >
                  <Text fontWeight="700" color="white" fontSize={[2]}>
                    <FormattedMessage
                      id="hero.cta_new"
                      defaults="NEW MORTGAGE"
                    />
                  </Text>
                  <Text color="backgroundDarkBlue">
                    <ChevronRight size={36} color="white" />
                  </Text>
                </Button>
              </Link>
            </Box>
            <Box
              flex={0.5}
              pl={[0, 0, 2]}
              pr={[0]}
              pt={[2, 0, 0]}
              flexDirection="column"
              align="flex-start"
              justify="center"
            >
              <Link to={`${intl.formatMessage({ id: "routes.calculator" })}/1`}>
                <Button
                  onClick={() =>
                    window.analytics.track("begin process", {
                      category: "calculate amount",
                      label: "How much can i get?",
                      location: "choice page",
                      language: getUserLanguage()
                    })
                  }
                  bg="actionPrimary"
                  pl={[1]}
                  pr={[1]}
                  size="fluid"
                  type="hero"
                  justify="space-between"
                  w={["280px"]}
                >
                  <Text fontWeight="700" color="white" fontSize={[2]}>
                    <FormattedMessage
                      id="hero.cta_renewal"
                      defaults="RENEWAL"
                    />
                  </Text>
                  <Text color="backgroundDarkBlue">
                    <ChevronRight size={36} color="white" />
                  </Text>
                </Button>
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>
    )
  }
}

export default Container



// WEBPACK FOOTER //
// ./src/containers/get-quote/get-quote.container.js